import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Typography from "@material-ui/core/Typography";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";

// @material-ui/icons
import Lock from "@material-ui/icons/Lock";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import { withRouter } from "react-router";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import { connect } from "react-redux";
import { pushRightPanel, pushLeftPanel } from "actions/dashboard";
import { pushBasemapasli } from "../../actions/portal";
import osm from "../../assets/basemap/osm.PNG";
import dark from "../../assets/basemap/dark.PNG";
import AutoCompleted from "./AutoCompleted";
import Select from "react-select";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import { fetchAlert } from "../../api/alert";
import { fetchShip } from "../../api/autocomplete/ship";
import { pushloggingx } from "../../api/login";

const options = [
  {
    map: "OSM",
    src: osm
  },
  {
    map: "DARK",
    src: dark
  }
];

class HeaderLinks extends React.Component {
  state = {
    open: false,
    openRightPanel: this.props.rightPanel,
    alerts: [],
    shipId: 0,
    shipName: "",
    selectedOption: null
  };

  componentDidMount() {
    this.getAlert();
  }

  getAlert = () => {
    // fetchAlert()
    //   .then(response => {
    //     if (response != null) {
    //
    //       this.setState({ alerts: response.data.results });
    //     }
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //   });
  };

  handleClickMenu = event => {
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.pushBasemapasli(options[index].map);
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    console.log(`Option selected:`, selectedOption);
  };

  fetchShipMent = ship => {
    fetchShip(ship)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleClick = () => {
    this.getAlert();
    this.setState({ open: !this.state.open });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  logout = () => {
    //if login dengan idaman
    if (localStorage.getItem("oauth") !== "") {
      // window.open(
      //   "https://identity.idaman.pertamina.com/logout",
      //   "MsgWindow",
      //   "width=600,height=600"
      // );
    }

    pushloggingx("Logout", "Logout")
      .then(response => {
        if (response != null) {
          // this.setState({ alerts: response.data.results });
          // console.log(this.state.alerts, "alert");
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        // this.props.history.push("/pages/login#logout");
      });

    localStorage.clear();

    this.props.history.push("/pages/login#logout");
  };

  fopenRightPanel = () => {
    this.props.pushRightPanel(!this.props.rightPanel);
    this.setState({ openRightPanel: !this.props.rightPanel });
  };

  fopenLeftPanel = () => {
    this.props.pushLeftPanel(!this.props.leftPanel);
  };

  handleSimple = e => {
    console.log(e);
    let label = e.nativeEvent.target.innerText;
    console.log(label);
    this.fetchShipMent(label);
  };

  render() {
    const { classes, rtlActive } = this.props;
    const { open } = this.state;
    const searchButton =
      classes.top +
      " " +
      classes.searchButton +
      " " +
      classNames({
        [classes.searchRTL]: rtlActive
      });
    const dropdownItem = classNames(
      classes.dropdownItem,
      classes.primaryHover,
      { [classes.dropdownItemRTL]: rtlActive }
    );
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });
    const managerClasses = classNames({
      [classes.managerClasses]: true
    });
    return (
      <div className={wrapper}>
        <Button
          style={{ color: "#004d99", fontSize: "12px" }}
          simple
          color="transparent"
          onClick={this.handleClickMenu}
          className={classes.linkText}
        >
          BASEMAP
        </Button>
        <Menu
          id="lock-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleCloseMenu}
        >
          {options.map((option, index) => (
            <MenuItem
              key={option}
              selected={index === this.state.selectedIndex}
              onClick={event => this.handleMenuItemClick(event, index)}
            >
              <div style={{ flexDirection: "row", fontSize: "10px" }}>
                <Typography variant="body2">{option.map}</Typography>
                <img
                  style={{
                    height: "60px",
                    width: "140px",
                    display: "block"
                  }}
                  alt="..."
                  src={option.src}
                />
              </div>
            </MenuItem>
          ))}
        </Menu>
        <Button
          color="transparent"
          aria-label="edit"
          justIcon
          onClick={this.fopenLeftPanel}
          round
          className={searchButton}
        >
          <Search
            style={{ fill: "#004d99" }}
            className={classes.headerLinksSvg + " " + classes.searchIcon}
          />
        </Button>
        <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Notifications"
            aria-owns={open ? "menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : ""
            }}
            buttonRef={node => {
              this.anchorEl = node;
            }}
          >
            <Notifications
              style={{ fill: "#004d99" }}
              className={
                classes.headerLinksSvg +
                " " +
                (rtlActive
                  ? classes.links + " " + classes.linksRTL
                  : classes.links)
              }
            />
            <span className={classes.notifications}>
              {this.state.alerts.length}
            </span>
            <Hidden mdUp implementation="css">
              <span onClick={this.handleClick} className={classes.linkText}>
                {rtlActive ? "إعلام" : "Notification"}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: true
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList role="menu">
                      {this.state.alerts.map((v, i) => (
                        <MenuItem
                          key={i}
                          onClick={this.handleClose}
                          className={dropdownItem}
                        >
                          {v.description}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
        <Button
          color="transparent"
          aria-label="Person"
          justIcon
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : ""
          }}
        >
          <Lock
            style={{ fill: "#004d99" }}
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
            onClick={this.logout}
          />
          <Hidden mdUp implementation="css">
            <span className={classes.linkText}>
              {rtlActive ? "الملف الشخصي" : "Profile"}
            </span>
          </Hidden>
        </Button>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
  pushBasemapasli: PropTypes.string
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel,
    basemapAsli: state.basemapAsli
  };
}

export default withStyles(headerLinksStyle)(
  withRouter(
    connect(
      mapStateToProps,
      { pushRightPanel, pushLeftPanel, pushBasemapasli }
    )(HeaderLinks)
  )
);
